export default {
  THUNDERSTRIKE3: {
    image: '/assets/branches/airsoft/badges/thunderstrike3.png',
    name: 'Operation Thunder Strike 3'
  },
  TCHERNO_2025: {
    image: '/assets/branches/airsoft/badges/op_tcherno_2025.png',
    name: 'OP Tschernobyl: Life in Danger — Blowout'
  },
  STORMTIDE_2025: {
    image: '/assets/branches/airsoft/badges/stormtide_chapterone.png',
    name: 'Storm Tide: Chapter One - 2025'
  },
  DARK_EMERGENCY_13: {
    image: '/assets/branches/airsoft/badges/dark-emergency-13.png',
    name: 'Dark Emergency 13'
  },
  DARK_EMERGENCY_12: {
    image: '/assets/branches/airsoft/badges/dark-emergency-12.png',
    name: 'Dark Emergency 12'
  },
  DARK_EMERGENCY_11: {
    image: '/assets/branches/airsoft/badges/dark-emergency-11.png',
    name: 'Dark Emergency 11'
  },
  DARK_EMERGENCY_10: {
    image: '/assets/branches/airsoft/badges/dark-emergency-10.png',
    name: 'Dark Emergency 10'
  },
  DARK_EMERGENCY_9: {
    image: '/assets/branches/airsoft/badges/dark-emergency-9.png',
    name: 'Dark Emergency 9'
  },
  OPERATION_SOURCE_LIGHTSIM: {
    image: '/assets/branches/airsoft/badges/operation-source-lightsim.png',
    name: 'Operation Source LightSim'
  },
  OPERATION_RISENFALL_LIGHTSIM: {
    image: '/assets/branches/airsoft/badges/operation-source-lightsim.png',
    name: 'Operation Risen Fall - LightSim'
  },
  OPERATION_TITAN_LIGHTSIM: {
    image: '/assets/branches/airsoft/badges/operation-titan-lightsim.png',
    name: 'Operation Titans Stand - LightSim'
  },
  FOUNDATION_MEMBER: {
    image: '/assets/branches/airsoft/badges/foundation-member.png',
    name: 'Gründungsmitglied'
  },
  MISSION_24H: {
    image: '/assets/branches/airsoft/badges/mission-24h.png',
    name: 'Mission 24H'
  },
  MISSION_24H_2025: {
    image: '/assets/branches/airsoft/badges/mission-24h_2025.png',
    name: 'Mission 24H - 2025'
  },
  OP: {
    image: '/assets/branches/airsoft/badges/op.png',
    name: 'OP'
  }
};
